import { OpenPayout } from '@mews-commander/data-access';
import { LocalizedLabel, LocalizedSmallParagraph } from '@mews-commander/ui';
import { Card, Divider, Highlight, Body, Stack } from '@optimus-web/core';
import { LocalizedCurrencyValue } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getLocalizedCurrencyValue } from '../utils';

export const OpenPayoutSummaryCard = ({
    openPayoutSummary: { net, gross, commission },
}: {
    openPayoutSummary: OpenPayout;
}) => (
    <Card padding="200">
        <Stack vertical spacing="200">
            <Stack vertical spacing="100">
                <LocalizedLabel textKey={TextKey.PayoutOpenBalance} as="div" />
                <Highlight size="small">
                    <LocalizedCurrencyValue value={{ value: net.value, currency: net.currencyCode }} />
                </Highlight>
            </Stack>
            <Divider />
            <Stack vertical spacing="100">
                <Highlight size="small">
                    <LocalizedLabel textKey={TextKey.PayoutBreakdown} as="div" />
                </Highlight>
                <Stack spacing="50" vertical>
                    <Stack distribution="space-between">
                        <LocalizedSmallParagraph textKey={TextKey.PayoutGross} variant="secondary" />
                        <Body size="small"> {getLocalizedCurrencyValue(gross)}</Body>
                    </Stack>
                    <Stack distribution="space-between">
                        <LocalizedSmallParagraph textKey={TextKey.PayoutCommission} variant="secondary" />
                        <Body size="small"> {getLocalizedCurrencyValue(commission)}</Body>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    </Card>
);
